import { IApp } from '../types/app';

export const loadApp = (): IApp => ({
    configuredExpanded: true,
    byodExpanded: true
})



// WEBPACK FOOTER //
// ./src/sub-projects/fusionfabric/services/app.ts